import store from "../../../../../../store";
import workspace from "../workspace";
import sqftShapeManager from "../../store/sqftShapeManager";
import Rectangle from "../shapes/layouts/rectangle";
import {CABINET_FILTER_NAMES, SHAPE_PART_ID} from "../../../../constants";
import Polygon from "../shapes/layouts/polygon";
import SlabAdditionalShape from "../slab/slabAdditionalShape";
import {
  createBlindCornerShape,
  createIroningBoardShape
} from "./cabinetShapesSpecialLayouts";
import {getCabinetDimensions, getRelatedFeatureMetadata, getSpecialShape} from "../../../../helpers/sqft3dArHelper";

export const SHAPE_LAYOUTS = {
  // old layout names deprecated
  upperLayoutType2: "upperLayoutType2",
  upperLayoutType4: "upperLayoutType4",
  upperLayoutType5: "upperLayoutType5",

  lowerLayoutType1: "lowerLayoutType1",
  lowerLayoutType2: "lowerLayoutType2",
  lowerLayoutType3: "lowerLayoutType3",
  lowerLayoutType4: "lowerLayoutType4",
  lowerLayoutType5: "lowerLayoutType5",

  // new layout names
  rectangle: "rectangle",
  LowerLCorner: "LowerLCorner", //SHAPE_LAYOUTS.lowerLayoutType1,
  LowerDullangle: "LowerDullangle", //SHAPE_LAYOUTS.lowerLayoutType2,
  LowerDualangle: "LowerDualangle", //SHAPE_LAYOUTS.lowerLayoutType2,
  LowerIroningBoard: "LowerIroningBoard",//SHAPE_LAYOUTS.lowerLayoutType3,
  LowerDimondShape: "LowerDimondShape",//SHAPE_LAYOUTS.lowerLayoutType4,
  LowerDimondCorner: "LowerDimondCorner",//SHAPE_LAYOUTS.lowerLayoutType5,

  UpperLCorner: "UpperLCorner",// SHAPE_LAYOUTS.upperLayoutType2,
  UpperDimondShape: "UpperDimondShape",//SHAPE_LAYOUTS.upperLayoutType4,
  UpperDimondCorner: "UpperDimondCorner",//SHAPE_LAYOUTS.upperLayoutType5,
  LowerIroningBoardRight: "LowerIroningBoardRight",
  LowerIroningBoardLeft: "LowerIroningBoardLeft",

  BlindCornerLeft: "BlindCornerLeft",
  BlindCornerRight: "BlindCornerRight"
};

export const SHAPE_UPPER_LAYOUTS = [
  SHAPE_LAYOUTS.UpperLCorner,
  SHAPE_LAYOUTS.UpperDimondShape,
  SHAPE_LAYOUTS.UpperDimondCorner,
];

export const SHAPE_LOWER_LAYOUTS = [
  SHAPE_LAYOUTS.LowerLCorner,
  SHAPE_LAYOUTS.LowerDullangle,
  SHAPE_LAYOUTS.LowerDualangle,
  SHAPE_LAYOUTS.LowerIroningBoard,
  SHAPE_LAYOUTS.LowerDimondShape,
  SHAPE_LAYOUTS.LowerDimondCorner,
  SHAPE_LAYOUTS.LowerIroningBoardRight,
  SHAPE_LAYOUTS.LowerIroningBoardLeft,
  SHAPE_LAYOUTS.BlindCornerLeft,
  SHAPE_LAYOUTS.BlindCornerRight,
];
export const SHAPE_DIAMOND_LAYOUTS = [
  SHAPE_LAYOUTS.LowerDimondCorner,
  SHAPE_LAYOUTS.LowerDimondShape,
  SHAPE_LAYOUTS.UpperDimondCorner,
  SHAPE_LAYOUTS.UpperDimondShape,
];

export const SHAPE_SQUARE_LAYOUTS = [
  // SHAPE_LAYOUTS.lowerLayoutType1,
  // SHAPE_LAYOUTS.lowerLayoutType4,
  // SHAPE_LAYOUTS.lowerLayoutType5,
  // SHAPE_LAYOUTS.upperLayoutType2,
  // SHAPE_LAYOUTS.upperLayoutType4,
  // SHAPE_LAYOUTS.upperLayoutType5,
  SHAPE_LAYOUTS.LowerLCorner,
  SHAPE_LAYOUTS.UpperLCorner,
  SHAPE_LAYOUTS.LowerDimondShape,
  SHAPE_LAYOUTS.UpperDimondShape,
  SHAPE_LAYOUTS.LowerDimondCorner,
  SHAPE_LAYOUTS.UpperDimondCorner,
];

export const SHAPE_L_CORNER_LAYOUTS = [
  SHAPE_LAYOUTS.lowerLayoutType1,
  SHAPE_LAYOUTS.LowerLCorner,
  SHAPE_LAYOUTS.upperLayoutType2,
  SHAPE_LAYOUTS.UpperLCorner,
];

export const SHAPE_DULL_CORNER_LAYOUTS = [
  SHAPE_LAYOUTS.lowerLayoutType2,
  SHAPE_LAYOUTS.LowerDullangle,
  SHAPE_LAYOUTS.LowerDualangle,
];

export const SHAPE_DIAMOND_SHAPE_LAYOUTS = [
  SHAPE_LAYOUTS.lowerLayoutType4,
  SHAPE_LAYOUTS.LowerDimondShape,
  SHAPE_LAYOUTS.upperLayoutType4,
  SHAPE_LAYOUTS.UpperDimondShape,
];

export const SHAPE_DIAMOND_CORNER_LAYOUTS = [
  SHAPE_LAYOUTS.lowerLayoutType5,
  SHAPE_LAYOUTS.LowerDimondCorner,
  SHAPE_LAYOUTS.upperLayoutType5,
  SHAPE_LAYOUTS.UpperDimondCorner,
];

export const SHAPE_CORNER_LAYOUTS = [
  SHAPE_LAYOUTS.lowerLayoutType1,
  SHAPE_LAYOUTS.lowerLayoutType2,
  SHAPE_LAYOUTS.lowerLayoutType4,
  SHAPE_LAYOUTS.lowerLayoutType5,
  SHAPE_LAYOUTS.upperLayoutType2,
  SHAPE_LAYOUTS.upperLayoutType4,
  SHAPE_LAYOUTS.upperLayoutType5,
  SHAPE_LAYOUTS.LowerLCorner,
  SHAPE_LAYOUTS.LowerDullangle,
  SHAPE_LAYOUTS.LowerDualangle,
  SHAPE_LAYOUTS.LowerDimondShape,
  SHAPE_LAYOUTS.LowerDimondCorner,
  SHAPE_LAYOUTS.UpperLCorner,
  SHAPE_LAYOUTS.UpperDimondShape,
  SHAPE_LAYOUTS.UpperDimondCorner,
];

export const IRONING_BOARD_DIRECTION = {
  left: 'left',
  right: 'right'
}

export const DIRECTION = {
  left: 'left',
  right: 'right'
}

export const SHAPE_LAYOUTS_WITHOUT_HANDLES = [
  SHAPE_LAYOUTS.LowerIroningBoardRight,
  SHAPE_LAYOUTS.LowerIroningBoardLeft,
]

// const LAYOUT_TYPES = {
//   upper: SHAPE_UPPER_LAYOUTS,
//   lower: SHAPE_LOWER_LAYOUTS,
// };

class CabinetShapes {
  constructor() {
    this.upperShapes = [];
    this.lowerShapes = [];
    this.otherShapes = [];
    this.additionalShapes = [];
    this.shapes = {
      /**
       *   |‾‾‾‾|
       *   |    /
       *   |__/
      */
      UpperDimondCorner: [
        // 'SM-DCW2436', 'SW-DCW2430', 'SM-DCW2442',
        // 'Providence Cabinets Shaker White 27" W, 36" H Diagonal Corner Wall Cabinet',
        // 'Providence Cabinets Shaker White 27" W, 42" H Diagonal Corner Wall Cabinet',
        // 'SW-W1230', 'SM-W1236', 'SM-W1242',
      ],
      /**
      *   |‾‾‾‾|
      *   |   _|
      *   |__|
      */
      UpperLCorner: [
        // 'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 36" H',
        // 'Providence Cabinets Shaker White 24" W, 30" H Diagonal Corner Wall Cabinet',
        // 'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 30"H',
        // 'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 42"H',
        // 'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 42" H',
      ],
      /**
       *   |‾‾‾‾‾|
       *   |   __|
       *   |__|
      */
      LowerLCorner: [
        //'SM-ERB36/BER36', 'Providence Cabinets Shaker White 33" Lazy Susan'
      ],
      /**
       *   |‾‾‾/
       *   |  >
       *   |/
      */
      LowerDullangle: [
        //'SW-BEC24'
      ],
      /**
       *   |‾‾‾|
       *   |   |
       *   | )
       */
      LowerIroningBoard: [
        //'SW-BES12'
      ],
      LowerIroningBoardRight: [
        //'SW-BES12'
      ],
      /**
       *   |‾‾‾‾|
       *   |    /
       *   |__/
       */
      UpperDimondShape: [],
      BlindCornerLeft: [
        'SW-BBCDL36',
        'SW-BBCL36',
        'SW-BBCDL48',
        'SW-BBCL48'
      ],
      BlindCornerRight: [
        'SW-BBCDR36',
        'SW-BBCR36',
        'SW-BBCDR48',
        'SW-BBCR48'
      ]
    };
    this.specialShapes = {
      LowerLCorner: SHAPE_LAYOUTS.LowerLCorner,
      LowerDullangle: SHAPE_LAYOUTS.LowerDullangle,
      LowerDualangle: SHAPE_LAYOUTS.LowerDualangle,
      LowerIroningBoard: SHAPE_LAYOUTS.LowerIroningBoard,
      LowerDimondShape: SHAPE_LAYOUTS.LowerDimondShape,
      LowerDimondCorner: SHAPE_LAYOUTS.LowerDimondCorner,
      LowerIroningBoardRight: SHAPE_LAYOUTS.LowerIroningBoardRight,
      LowerIroningBoardLeft: SHAPE_LAYOUTS.LowerIroningBoardLeft,
      BlindCornerLeft: SHAPE_LAYOUTS.BlindCornerLeft,
      BlindCornerRight: SHAPE_LAYOUTS.BlindCornerRight,

      UpperLCorner: SHAPE_LAYOUTS.UpperLCorner,
      UpperDimondShape: SHAPE_LAYOUTS.UpperDimondShape,
      UpperDimondCorner: SHAPE_LAYOUTS.UpperDimondCorner,
    }
  }

  addShape = (feature, parentFeature, position = null) => {
    const dimensions = getCabinetDimensions(feature, parentFeature);
    const shapeLayout = this.getShapeLayout(feature, parentFeature);

    return this.addShapeHelper(
      'square', feature.partId, shapeLayout, dimensions, position, feature, parentFeature
    );
  };

  addShapeHelper = (shapeType, partId, shapeLayout, dimensions, position, feature, parentFeature) => {
    const shapeLines = this.getShapeLines(shapeLayout, dimensions);
    const shapeParams = { shapeCabinet: true, canSnap: true, ...dimensions, shapeLayout };
    const shapeId = sqftShapeManager.addShape(shapeLines, shapeType, position, partId, null, shapeParams);
    sqftShapeManager.setShapeFeatureId(shapeId, feature.dbFeature.id);
    sqftShapeManager.setShapeRelatedParentFeatureId(shapeId, parentFeature.dbFeature.id, parentFeature.partId);

    console.log("Feature SharedFeatureName", feature.dbFeature.sharedFeatureName);
    console.log("Feature Metadata", getRelatedFeatureMetadata(feature, parentFeature));

    const shape = workspace.getShapeById(shapeId);
    if (shape && typeof shape.applyRelatedParentWizardProperties === "function") {
      shape.applyRelatedParentWizardProperties(parentFeature);
    }

    const reduxState = store.getState();
    if (shape && shape.shapeCabinet && reduxState.sqftResourceState.selectedHinge) {
      shape.shapeCabinet.deleteAttachedFeatures(CABINET_FILTER_NAMES.hinges);
      shape.shapeCabinet.generateAttachedFeatures(CABINET_FILTER_NAMES.hinges);
    }

    return shapeId;
  };

  getShapeLayout = (feature, parentFeature) => {
    const thirdPartyAR3DMetaData = getRelatedFeatureMetadata(feature, parentFeature);
    const specialShape = getSpecialShape(thirdPartyAR3DMetaData);
    if (specialShape) {
      const specialLayoutName = specialShape.replace(/\s/g, "");
      if (this.specialShapes[specialLayoutName]) {
        return this.specialShapes[specialLayoutName]
      }
    }

    // Hardcoded Layouts
    for (const layout of Object.keys(SHAPE_LAYOUTS)) {
      if (this.shapes[layout] && feature.dbFeature && this.shapes[layout].includes(feature.dbFeature.sharedFeatureName) ||
        (feature.part && this.shapes[layout].includes(feature.part.dbFeature.sharedFeatureName))) {
        return layout;
      }
    }

    return SHAPE_LAYOUTS.rectangle;
  };

  getShapeLines = (shapeLayout, { width, height, depth, diamondLength}) => {
    void height;
    let margin = diamondLength ? width - diamondLength : 0;
    switch (shapeLayout) {
      case SHAPE_LAYOUTS.lowerLayoutType1:
      case SHAPE_LAYOUTS.LowerLCorner:
      case SHAPE_LAYOUTS.upperLayoutType2:
      case SHAPE_LAYOUTS.UpperLCorner:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: depth },
          { x: depth, y: width },
          { x: 0, y: width }
        ]), true, true);
      case SHAPE_LAYOUTS.lowerLayoutType2:
      case SHAPE_LAYOUTS.LowerDullangle:
      case SHAPE_LAYOUTS.LowerDualangle:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width - 8, y: depth - 8 },
          { x: 0, y: depth }
        ]), true, true);
      case SHAPE_LAYOUTS.lowerLayoutType3:
      case SHAPE_LAYOUTS.LowerIroningBoard:
      case SHAPE_LAYOUTS.LowerIroningBoardRight:
        return createIroningBoardShape(width, depth, width, IRONING_BOARD_DIRECTION.right);
      case SHAPE_LAYOUTS.LowerIroningBoardLeft:
        return createIroningBoardShape(width, depth, width, IRONING_BOARD_DIRECTION.left);
      case SHAPE_LAYOUTS.BlindCornerRight:
        return createBlindCornerShape(width, depth, height, DIRECTION.right);
      case SHAPE_LAYOUTS.BlindCornerLeft:
        return createBlindCornerShape(width, depth, height, DIRECTION.left);
      case SHAPE_LAYOUTS.lowerLayoutType4:
      case SHAPE_LAYOUTS.LowerDimondShape:
      case SHAPE_LAYOUTS.upperLayoutType4:
      case SHAPE_LAYOUTS.UpperDimondShape:
        return new Polygon(this.createPoints([
          { x: margin, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: width },
          { x: 0, y: width },
          { x: 0, y: margin }
        ]), true, true);
      case SHAPE_LAYOUTS.lowerLayoutType5:
      case SHAPE_LAYOUTS.LowerDimondCorner:
      case SHAPE_LAYOUTS.upperLayoutType5:
      case SHAPE_LAYOUTS.UpperDimondCorner:
        return new Polygon(this.createPoints([
          { x: margin, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: depth },
          { x: depth, y: width },
          { x: 0, y: width },
          { x: 0, y: margin }
        ]), true, true);
      default:
        return new Rectangle(width, depth);
    }
  };

  createPoints = (coords) => coords;

  resetUpperShapes = () => {
    this.upperShapes = [];
  };

  importData = (data = []) => {
    if (!Array.isArray(data)) {
      return;
    }

    //this.resetBacksplashes();
    data.forEach(activeBacksplashData => {
      const lineId = activeBacksplashData?.line?.id;
      const line = workspace.getLineById(lineId);

      if (!line || !activeBacksplashData?.backsplashShape) {
        console.warn("Skipping cabinet additional shape import: missing parent line or shape", activeBacksplashData);
        return;
      }

      const shape = workspace.importShape(activeBacksplashData.backsplashShape);
      if (!shape) {
        console.warn("Skipping cabinet additional shape import: shape import failed", activeBacksplashData);
        return;
      }

      shape.deregisterEvents();
      const slabAdditionalShape = new SlabAdditionalShape(line, shape.id);
      this.addActiveBacksplash(slabAdditionalShape);
    });
  };

  exportData = () => {
    return this.additionalShapes.reduce((exportData, slab) => {
      const backsplashShape = workspace.getShapeById(slab?.backsplashShapeId);
      const line = slab?.line;

      if (
        !backsplashShape ||
        !line ||
        typeof backsplashShape.export !== "function" ||
        typeof line.export !== "function" ||
        backsplashShape.partId === SHAPE_PART_ID.seamPiece
      ) {
        return exportData;
      }

      exportData.push({
        backsplashShape: backsplashShape.export(),
        line: line.export(),
      });

      return exportData;
    }, []);
  };

  addActiveBacksplash = (slabAdditionalShape) => {
    this.additionalShapes.push(slabAdditionalShape);
  };

  findAdditionalShapeByLine = (line) => {
    return this.additionalShapes.find(additionalShape => additionalShape?.line?.id === line?.id);
  };

  removeActiveBacksplashByLine = (line) => {
    this.additionalShapes = this.additionalShapes.filter(shape => {
      if (shape?.line?.id === line?.id) {
        workspace.removeShapeById(shape.backsplashShapeId);
        return false;
      }
      return true;
    });
  };

  removeShapeFromList = (shapeToRemove) => {
    this.additionalShapes = this.additionalShapes.filter(additionalShape => additionalShape.backsplashShapeId !== shapeToRemove.id);
  };
}

export default CabinetShapes;
